<script lang="ts" setup>
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
    Loader2,
    // MapPinOff,
    Settings2,
    Play,
    ChevronDown,
    Wallet,
    VolumeX,
    UserRoundX,
    WifiOff,
} from "lucide-vue-next";
import { myDeliveryteams, isMyDeliveryteamsLoading, deliveryteamsWithNegativeBalance } from '@deliveryteam-spa-orders-vue/refs/MyDeliveryteams'
import HeaderOnly from '@deliveryteam-spa-orders-vue/layouts/HeaderOnly.vue';
import { Button } from "@/components/ui/button";
import { onMounted, ref } from "vue";
import { activeDeliveryteams } from '@deliveryteam-spa-orders-vue/refs/MyDeliveryteams';
import { playBlankAudioLoop, isAbleToPlayAudio, watchNewOrders } from "@deliveryteam-spa-orders-vue/utils/playAudio";
import { loadOrders } from "@deliveryteam-spa-orders-vue/refs/RecentOrders";
import { Dialog, DialogHeader, DialogTitle, DialogDescription, DialogScrollContent, DialogClose, DialogFooter } from "@/components/ui/dialog";
// import {
//     AlertDialog,
//     AlertDialogHeader,
//     AlertDialogTitle,
//     AlertDialogDescription,
//     AlertDialogContent,
//     AlertDialogFooter,
// } from "@/components/ui/alert-dialog";
// import {
//     hasAccessibleUserLocation,
//     isUserLocationWatchActive,
//     locationWatchError,
//     retryUserLocationAccess,
// } from "@deliveryteam-spa-orders-vue/refs/UserCurrentLocation";
import SettingsView from "./settings/SettingsView.vue";
// import { MySettingsDeliveryteam } from "@deliveryteam-spa-orders-vue/refs/MySettings";
import OrdersList from "./OrdersList.vue";
import MyOrdersMap from "@deliveryteam-spa-orders-vue/components/MyOrdersMap.vue";
import { toggleCourierActive } from '@deliveryteam-spa-orders-vue/utils/toggleCourierActive';
import { isSettingsDialogOpen } from "./settings/settings-ref";
import {
    foregroundLocationPermission,
    backgroundLocationPermission,
    requestForegroundLocationPermission,
    requestBackgroundLocationPermission
} from '@deliveryteam-spa-orders-vue/refs/locationPermission';

const reload = () => {
    window.location.reload();
}

onMounted(() => {
    playBlankAudioLoop();
    watchNewOrders();
});

const isDev = import.meta.env.DEV;
const deliveryteamOrderId = ref('');

</script>

<template>
    <HeaderOnly>
        <div class="max-w-3xl mx-auto">


            <!-- <div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div class="flex flex-col gap-1">
                <h3 class="text-2xl font-bold tracking-tight">
                    <Deliveryteam class="inline-block mr-1" />
                    My Deliveryteams
                </h3>
                <p class="text-muted-foreground text-sm">As a manager, you can view and manage all your deliveryteams
                    below.</p>
            </div>
        </div> -->

            <div v-if="isMyDeliveryteamsLoading">
                <div class="flex justify-center items-center h-screen">
                    <Loader2 class="w-20 h-20 animate-spin" />
                </div>
            </div>

            <div v-if="!foregroundLocationPermission?.granted || !backgroundLocationPermission?.granted"
                 class="bg-destructive text-destructive-foreground rounded-md p-4">
                <div>
                    <p>Location permission is required</p>
                </div>
                <div v-if="!foregroundLocationPermission?.granted"
                     class="p-4">
                    <Button @click="requestForegroundLocationPermission()">
                        Allow While Using APP
                    </Button>
                </div>
                <div v-else>
                    <div v-if="!backgroundLocationPermission?.granted">
                        <Button @click="requestBackgroundLocationPermission()">
                            Change to Always Allow
                        </Button>
                    </div>
                </div>
            </div>

            <div class="px-2 py-0">
                <template v-if="deliveryteamsWithNegativeBalance.length > 0 && !isMyDeliveryteamsLoading">
                    <details v-for="deliveryteam in deliveryteamsWithNegativeBalance"
                             :key="deliveryteam.id"
                             class="group mb-2 overflow-hidden rounded-xl border border-destructive/35 bg-gradient-to-br from-destructive/18 via-background to-background text-foreground shadow-sm ring-1 ring-destructive/10 transition-[box-shadow] hover:shadow-md [&::-webkit-details-marker]:hidden">
                        <summary
                                 class="flex cursor-pointer select-none items-center gap-2.5 px-3 py-2 text-sm font-semibold text-destructive outline-none [&::-webkit-details-marker]:hidden focus-visible:ring-2 focus-visible:ring-destructive/40 [&::marker]:content-none">
                            <span
                                  class="flex size-8 shrink-0 items-center justify-center rounded-lg bg-destructive/15 text-destructive">
                                <Wallet class="size-4" />
                            </span>
                            <span class="min-w-0 flex-1 leading-tight">
                                Negative balance · {{ deliveryteam.name.substring(0, 17) }}{{
                                    deliveryteam.name.length > 17 ? '…' : '' }}
                            </span>
                            <ChevronDown
                                         class="size-4 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180" />
                        </summary>
                        <div
                             class="space-y-2 border-t border-destructive/15 bg-muted/30 px-3 py-2.5 text-xs leading-relaxed text-muted-foreground">
                            <p>
                                Deliveryteam balance is negative, so all payment methods except Stripe are disabled.
                            </p>
                            <p>
                                Please go to 'Dashboard' -> 'My Deliveryteams' -> '{{ deliveryteam.name }}' -> 'Balance'
                                page to top up your balance.
                            </p>
                            <p>
                                If Stripe is enabled, the next Stripe order will include a higher application fee to
                                cover the negative balance automatically.
                            </p>
                        </div>
                    </details>
                </template>

                <!-- <div v-if="!notificationPermissionRef?.granted">
                    <Button @click="requestNotificationPermission()">
                        Request notification permission
                    </Button>
                </div>
                <div v-if="notificationPermissionRef?.granted">
                    <Button @click="showSampleNotification()">
                        Show sample notification
                    </Button>
                    <br>
                    <Button @click="startPushTokenListener()">
                        startPushTokenListener
                    </Button>
                </div> -->

                <div v-if="!isMyDeliveryteamsLoading && !isAbleToPlayAudio"
                     class="group mb-2 overflow-hidden rounded-xl border border-amber-500/35 bg-gradient-to-br from-amber-500/12 via-background to-background text-foreground shadow-sm ring-1 ring-amber-500/10 transition-[box-shadow] hover:shadow-md [&::-webkit-details-marker]:hidden">
                    <div
                         class="flex cursor-pointer select-none items-center gap-2.5 px-3 py-2 text-sm font-semibold text-amber-950 dark:text-amber-100 outline-none [&::-webkit-details-marker]:hidden focus-visible:ring-2 focus-visible:ring-amber-500/40 [&::marker]:content-none">
                        <span
                              class="flex size-8 shrink-0 items-center justify-center rounded-lg bg-amber-500/20 text-amber-700 dark:text-amber-300">
                            <VolumeX class="size-4" />
                        </span>
                        <Button class="w-full sm:w-auto"
                                variant="outline"
                                size="sm"
                                @click="playBlankAudioLoop()">
                            <Play class="inline-block mr-1 size-3.5" />
                            Enable audio notifications
                        </Button>
                    </div>
                    <div
                         class="space-y-3 border-t border-amber-500/15 bg-muted/30 px-3 py-2.5 text-xs leading-relaxed text-muted-foreground">
                        <p>
                            To enable audio notifications, click the button above or allow sound in your browser
                            settings.
                        </p>
                    </div>
                </div>

                <details v-if="myDeliveryteams.length === 0 && !isMyDeliveryteamsLoading"
                         class="group mb-2 overflow-hidden rounded-xl border border-destructive/35 bg-gradient-to-br from-destructive/18 via-background to-background text-foreground shadow-sm ring-1 ring-destructive/10 transition-[box-shadow] hover:shadow-md [&::-webkit-details-marker]:hidden">
                    <summary
                             class="flex cursor-pointer select-none items-center gap-2.5 px-3 py-2 text-sm font-semibold text-destructive outline-none [&::-webkit-details-marker]:hidden focus-visible:ring-2 focus-visible:ring-destructive/40 [&::marker]:content-none">
                        <span
                              class="flex size-8 shrink-0 items-center justify-center rounded-lg bg-destructive/15 text-destructive">
                            <UserRoundX class="size-4" />
                        </span>
                        <span class="min-w-0 flex-1 leading-tight">No deliveryteam manager access</span>
                        <ChevronDown
                                     class="size-4 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180" />
                    </summary>
                    <div
                         class="space-y-3 border-t border-destructive/15 bg-muted/30 px-3 py-2.5 text-xs leading-relaxed text-muted-foreground">
                        <p>
                            You are not a order manager for any deliveryteams. To manage orders for your deliveryteams,
                            please contact your support or administrator.
                        </p>
                        <Button size="sm"
                                variant="outline"
                                class="w-full sm:w-auto"
                                @click="reload()">
                            Refresh this page once you are a manager
                        </Button>
                    </div>
                </details>

                <details v-if="myDeliveryteams.length > 0 && activeDeliveryteams.length === 0 && !isMyDeliveryteamsLoading"
                         class="group mb-2 overflow-hidden rounded-xl border border-muted-foreground/25 bg-card text-card-foreground shadow-sm ring-1 ring-border/60 transition-[box-shadow] hover:shadow-md [&::-webkit-details-marker]:hidden">
                    <summary
                             class="flex cursor-pointer select-none items-center gap-2.5 px-3 py-2 text-sm font-semibold outline-none [&::-webkit-details-marker]:hidden focus-visible:ring-2 focus-visible:ring-ring [&::marker]:content-none">
                        <span
                              class="flex size-8 shrink-0 items-center justify-center rounded-lg bg-destructive/15 text-destructive">
                            <WifiOff class="size-4" />
                        </span>
                        <span class="min-w-0 flex-1 leading-tight">
                            <span
                                  class="mr-2 inline-flex items-center rounded-md bg-destructive/90 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-destructive-foreground">
                                Offline
                            </span>
                        </span>
                        <ChevronDown
                                     class="size-4 shrink-0 text-muted-foreground transition-transform duration-200 group-open:rotate-180" />
                    </summary>
                    <div class="border-t border-border/80 bg-muted/20 px-3 py-2">
                        <div class="max-h-[200px] overflow-y-auto text-sm">
                            <div v-for="deliveryteam in myDeliveryteams"
                                 :key="deliveryteam.id">
                                <div class="flex flex-wrap items-center gap-2 py-2">
                                    <span class="text-muted-foreground text-xs">Go online</span>
                                    <Switch :id="`deliveryteam-${deliveryteam.id}`"
                                            :checked="deliveryteam.isUserActivatedTeam"
                                            @update:checked="(isActive) => toggleCourierActive(deliveryteam.id, isActive)" />
                                    <Label :for="`deliveryteam-${deliveryteam.id}`"
                                           class="font-medium">
                                        {{ deliveryteam.name }}
                                        <span v-if="!deliveryteam.isUserActivatedTeam"
                                              class="ml-1 inline rounded-md bg-destructive/15 px-1.5 py-0.5 text-[10px] font-semibold text-destructive">
                                            Offline
                                        </span>
                                    </Label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- There is no deliveryteam enabled.
                <br>
                Please open the settings and enable a deliveryteam to receive orders in real time.
                <br>
                <Button @click="isSettingsDialogOpen = true;"
                        variant="outline">
                    <Settings2 class="inline-block mr-1" />
                    Settings
                </Button> -->
                </details>
            </div>

            <Dialog v-model:open="isSettingsDialogOpen">
                <DialogScrollContent class="w-full max-w-7xl">
                    <DialogHeader>
                        <DialogTitle>Settings</DialogTitle>
                        <DialogDescription />
                    </DialogHeader>

                    <SettingsView />

                    <DialogFooter>
                        <DialogClose as-child>
                            <Button variant="secondary"
                                    class="w-full">
                                Close
                            </Button>
                        </DialogClose>
                    </DialogFooter>
                </DialogScrollContent>
            </Dialog>

            <MyOrdersMap class="mb-0">
                <Button variant="outline"
                        @click="isSettingsDialogOpen = true;"
                        class="">
                    <Settings2 class="inline-block mr-1" />
                    <span class="hidden sm:inline">
                        Settings
                    </span>
                </Button>
            </MyOrdersMap>



            <!-- Space + divider: map stays “scout”, list is the work queue; pb leaves room for the fixed closest-order dock. -->
            <!-- Padding tracks teleported dock height (see OrdersList ResizeObserver → --closest-order-dock-h) -->
            <div class="pt-2 pb-[max(1rem,calc(var(--closest-order-dock-h,0px)+0.5rem))]">
                <OrdersList />

                <div class="flex items-center gap-2 p-4 border-t"
                     v-for="deliveryteam in activeDeliveryteams">
                    <Switch :id="`deliveryteam-${deliveryteam.id}`"
                            :checked="deliveryteam.isUserActivatedTeam"
                            @update:checked="(isActive) => toggleCourierActive(deliveryteam.id, isActive)" />
                    <Label :for="`deliveryteam-${deliveryteam.id}`">
                        Go offline: {{ deliveryteam.name }}
                    </Label>
                </div>

                <div v-if="isDev">
                    <input type="text"
                           placeholder="deliveryteamOrderId"
                           v-model="deliveryteamOrderId" />
                    <Button @click="loadOrders(myDeliveryteams[0].id, [deliveryteamOrderId])"
                            variant="secondary">
                        debug order
                    </Button>
                </div>
            </div>
        </div>

        <!-- Blocks the dashboard until the browser provides coordinates (Courier updates + map). -->
        <!-- <AlertDialog :open="!hasAccessibleUserLocation">
            <AlertDialogContent class="gap-6 border-destructive/25 sm:max-w-md">
                <AlertDialogHeader>
                    <AlertDialogTitle class="flex items-center gap-2 text-lg">
                        <MapPinOff class="size-5 shrink-0 text-destructive" />
                        Location access required
                    </AlertDialogTitle>
                    <AlertDialogDescription class="text-left leading-relaxed">
                        <template v-if="locationWatchError">
                            <p class="text-foreground">{{ locationWatchError }}</p>
                            <p class="mt-3">
                                Allow location to get accurate courier orders in your local area.
                            </p>
                        </template>
                        <template v-else-if="isUserLocationWatchActive">
                            <p class="inline-flex flex-wrap items-center gap-2 text-foreground">
                                <Loader2 class="size-4 shrink-0 animate-spin text-muted-foreground" />
                                Waiting for your current location…
                            </p>
                            <p class="mt-3">
                                We need your location to show you the closest courier orders.
                            </p>
                        </template>
                        <template v-else>
                            <p class="text-foreground">
                                We need your location to show you the closest courier orders.
                            </p>
                        </template>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <Button type="button"
                            class="w-full sm:w-auto"
                            @click="retryUserLocationAccess()">
                        Ask for location permission
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog> -->

    </HeaderOnly>
</template>
